import { FunctionComponent, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  EngagePostMessageActions,
  ImagesService,
  SendMessage,
  useIframeEngageActionListener,
} from '../services';
import {
  AddPhotosButton,
  PhotoPreview,
  SavePhotoToContactDialogContent,
} from './save-to-contact-modal.styles';

interface SaveToContactModalProps {
  accessToken: string;
  api1Origin: string;
  engageOrigin: string;
}

export const SaveToContactModal: FunctionComponent<SaveToContactModalProps> = ({
  accessToken,
  api1Origin,
  engageOrigin,
}) => {
  const eventBody = useIframeEngageActionListener({
    engageOrigin,
    action: EngagePostMessageActions.OPEN_SAVE_TO_CONTACT_MODAL,
  });
  const [contactId, setContactId] = useState('');
  const [open, setOpen] = useState(false);
  const [photoUrl, setPhotoUrl] = useState('');

  useEffect(() => {
    setOpen(eventBody != null);

    if (eventBody) {
      if (eventBody.associationType === 'contact') {
        setContactId(eventBody.associationId);
      }
      setPhotoUrl(eventBody.photoUrl);
    }
  }, [eventBody]);

  const handleClose = () => {
    setOpen(false);
    setContactId('');
  };

  const handleSavePhoto = async () => {
    const imagesService = new ImagesService(
      engageOrigin,
      api1Origin,
      accessToken
    );
    const media = await imagesService.savePhotoByUrlToContact(
      contactId,
      photoUrl
    );
    const payload = { media };

    SendMessage(payload, engageOrigin, true);
    handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby=" save-photo-to-contact-title"
        aria-describedby="save-photo-to-contact-description"
      >
        <DialogTitle id="save-photo-to-contact-title">
          {'Save Photo to Contact'}
        </DialogTitle>
        <DialogContent>
          <SavePhotoToContactDialogContent>
            <PhotoPreview src={photoUrl}></PhotoPreview>
          </SavePhotoToContactDialogContent>
        </DialogContent>
        <DialogActions>
          <Button data-e2e="cancel-save-photo-to-contact" onClick={handleClose}>
            Cancel
          </Button>
          {/* Intentionally disabled but kept to align with the modal flow */}
          <AddPhotosButton
            data-e2e="save-photo-to-contact"
            onClick={handleSavePhoto}
          >
            Save Photo
          </AddPhotosButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};
